module.exports = __webpack_public_path__ + "static/media/DSC_2547_h264_480sd.390f0cdc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/DSC_2547_h264_480sd.mp4
// module id = 35
// module chunks = 0